import MotionProvider from './MotionProvider';

export default MotionProvider;
